import styled from 'styled-components';

export const PlayerCard = styled.div<{ isGoalieView?: boolean }>`
  background-color: white;
  border-radius: 8px;
  padding: 1rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: grid;
  grid-template-columns: ${props => props.isGoalieView 
    ? '300px repeat(6, 1fr)' 
    : '300px repeat(6, 1fr)'};
  align-items: center;
  gap: 1rem;
  
  .player-header {
    display: flex;
    align-items: center;
    gap: 1rem;
    min-width: 0; // Enable text truncation
    
    img {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      object-fit: cover;
      flex-shrink: 0;
    }
    
    .player-info {
      min-width: 0; // Enable text truncation
      
      h3 {
        color: var(--primary);
        margin: 0;
        font-size: 1rem;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        .player-number {
          color: var(--gray);
          font-weight: normal;
          margin-left: 0.25rem;
        }
      }
      
      .position {
        color: var(--gray);
        font-size: 0.875rem;
      }
    }
  }
  
  .stat {
    text-align: center;
    padding: 0.5rem;
    background-color: #f5f5f5;
    border-radius: 4px;
    
    .value {
      font-size: 1.25rem;
      font-weight: bold;
      color: var(--primary);
      margin-bottom: 0.25rem;
    }
    
    .label {
      font-size: 0.75rem;
      color: var(--gray);
    }
  }

  @media (max-width: 1024px) {
    grid-template-columns: ${props => props.isGoalieView 
      ? '250px repeat(6, 1fr)' 
      : '250px repeat(6, 1fr)'};
    font-size: 0.9rem;
    
    .stat {
      .value {
        font-size: 1rem;
      }
      
      .label {
        font-size: 0.7rem;
      }
    }
  }

  @media (max-width: 768px) {
    grid-template-columns: ${props => props.isGoalieView 
      ? '2fr repeat(6, 1fr)' 
      : '2fr repeat(6, 1fr)'};
    gap: 0.5rem;
    padding: 0.75rem;
    font-size: 0.8rem;

    .player-header {
      img {
        display: none;
      }

      .player-info {
        width: 100%;
        
        h3 {
          font-size: 0.9rem;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 100%;
        }
        
        .position {
          font-size: 0.7rem;
        }
      }
    }

    .stat {
      padding: 0.25rem;
      
      .value {
        font-size: 0.9rem;
        margin-bottom: 0;
      }
      
      .label {
        display: none;
      }
    }
  }

  @media (max-width: 480px) {
    grid-template-columns: ${props => props.isGoalieView 
      ? '120px repeat(6, 1fr)' 
      : '120px repeat(6, 1fr)'};
    font-size: 0.75rem;
    padding: 0.5rem;
    gap: 0.25rem;

    .player-header {
      .player-info {
        h3 {
          font-size: 0.8rem;
        }
      }
    }

    .stat {
      .value {
        font-size: 0.8rem;
      }
    }
  }
`;

export const PlayerName = styled.h3`
  color: var(--primary);
  margin: 0;
  font-size: 1rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  transition: color 0.2s ease;

  &:hover {
    color: var(--primary-dark);
    text-decoration: underline;
  }

  .player-number {
    color: var(--gray);
    font-weight: normal;
    margin-left: 0.25rem;
  }
`;